import { render, staticRenderFns } from "./offset.vue?vue&type=template&id=a9c97114&"
import script from "./offset.vue?vue&type=script&lang=js&"
export * from "./offset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports